const blogName = 'elettrica'
const helpCenter = 'help'
/**
 * Categories
 */
const CATEGORY_ENUM = {
  'LUCE_GAS': 'categoria_luce-e-gas',
  'MOBILITA_ELETTRICA': 'categoria_mobilita-elettrica',
  'FOTOVOLTAICO': 'categoria_fotovoltaico',
  'ULTIME_TEAM': 'categoria_ultime-dal-team'
}
const categories = {
  [CATEGORY_ENUM.LUCE_GAS]: {
    ghostSlug: 'categoria_luce-e-gas',
    postPath: 'luce-gas',
    categoryPath: 'luce-gas',
    label: 'Luce & Gas',
  },
  [CATEGORY_ENUM.MOBILITA_ELETTRICA]: {
    ghostSlug: 'categoria_mobilita-elettrica',
    postPath: 'mobilita',
    categoryPath: 'mobilita',
    label: 'Mobilità elettrica',
  },
  [CATEGORY_ENUM.FOTOVOLTAICO]: {
    ghostSlug: 'categoria_fotovoltaico',
    postPath: 'fotovoltaico',
    categoryPath: 'fotovoltaico',
    label: 'Fotovoltaico',
  },
  [CATEGORY_ENUM.ULTIME_TEAM]: {
    ghostSlug: 'categoria_ultime-dal-team',
    postPath: 'ultime-dal-team',
    categoryPath: 'ultime-dal-team',
    label: 'Ultime dal team',
  }
}

/**
 * Lens
 */
const LENS_ENUM = {
  'NOVITA': 'lente_novita',
  'VIDEO': 'lente_video',
  'INCENTIVI': 'lente_incentivi',
  'COME_FARE': 'lente_come-fare-a',
  'VOCE_ESPERTO': 'lente_voce-dell-esperto'
}
const lenses = {
  [LENS_ENUM.COME_FARE]: {
    ghostSlug: 'lente_come-fare-a',
    postPath: 'come-fare'
  },
  [LENS_ENUM.INCENTIVI]: {
    ghostSlug: 'lente_incentivi',
    postPath: 'incentivi'
  },
  [LENS_ENUM.NOVITA]: {
    ghostSlug: 'lente_novita',
    postPath: 'novita'
  },
  [LENS_ENUM.VIDEO]: {
    ghostSlug: 'lente_video',
    postPath: 'video'
  },
  [LENS_ENUM.VOCE_ESPERTO]: {
    ghostSlug: 'lente_voce-dell-esperto',
    postPath: 'voce-esperto'
  },
}

/**
 * Authors
 */
const AUTHORS_ENUM = {
  'REDAZIONE': 'autore_redazione-tate',
  'PIETRO': 'autore_pietro-lubello'
}
const authors = {
  [AUTHORS_ENUM.REDAZIONE]: {
    name: 'La redazione di Tate'
  },
  [AUTHORS_ENUM.PIETRO]: {
    name: 'Pietro Lubello'
  }
}

module.exports.blogName = blogName
module.exports.helpCenterName = helpCenter
module.exports.CATEGORY_ENUM = CATEGORY_ENUM
module.exports.categories = categories

module.exports.LENS_ENUM = LENS_ENUM
module.exports.lenses = lenses

module.exports.AUTHORS_ENUM = AUTHORS_ENUM
module.exports.authors = authors
